/** Billing / session flag while a member chose cash and is waiting for staff to mark Paid. */
export const PAY_CASH_STATUS = "PAY_CASH";

export const CASH_PENDING_ALLOWED_PAGES = ["LandingPage", "DigitalCardPage"];

function looksLikePayCash(value) {
  if (value == null || value === false) return false;
  const v = String(value).trim().toUpperCase().replace(/[\s-]+/g, "_");
  return (
    v === "PAY_CASH" ||
    v === "CASH" ||
    v === "CASH_PENDING" ||
    v === "PENDING_CASH" ||
    v === "BETALA_KONTANT"
  );
}

function looksLikePaid(value) {
  if (value == null || value === false) return false;
  const v = String(value).trim().toUpperCase().replace(/[\s-]+/g, "_");
  return v === "BETALD" || v === "PAID";
}

/**
 * True when GET /api/me (or billing on the member) says cash payment is pending.
 * Admins and coaches are never restricted.
 */
export function isCashPaymentPending(me, userInfo = null) {
  const row = Array.isArray(userInfo) ? userInfo[0] : userInfo;
  if (row?.isAdmin || row?.isCoach) return false;
  if (me?.hasPaid || row?.hasPaid) return false;

  const access = String(me?.membershipAccess || "").toLowerCase();
  // Period (HT/VT) cash is a Finance flag only. Full membership access must not lock the app.
  if (access === "full") return false;
  if (access === "cash_pending" || access === "pay_cash") return true;

  const statusCandidates = [
    me?.paymentStatus,
    me?.billing?.paymentStatus,
    me?.billingDisplayStatus,
    me?.billing?.billingDisplayStatus,
    row?.paymentStatus,
    row?.billing?.paymentStatus,
    row?.billingDisplayStatus,
    row?._billing?.paymentStatus,
  ];
  if (statusCandidates.some(looksLikePaid)) return false;

  if (access === "payment_required" && statusCandidates.some(looksLikePayCash)) return true;

  if (
    String(me?.pendingPaymentMethod || me?.billing?.pendingPaymentMethod || row?.pendingPaymentMethod || "")
      .trim()
      .toLowerCase() === "cash"
  ) {
    return true;
  }

  return false;
}
